import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lms-approval-mobile-switch-confirmation',
  templateUrl: './mobile-switch-confirmation.component.html',
  styleUrls: ['./mobile-switch-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SandboxMobileSwitchConfirmationComponent {}
